import type { Todo } from "@listto/powersync";

/**
 * Checks if a todo is overdue based on its due date and completion status.
 */
export function checkIsOverdue(dueDate: string | null | undefined, completed: boolean): boolean {
  if (!dueDate || completed) {
    return false;
  }
  return new Date(dueDate) < new Date();
}

/**
 * Determines if a todo has any metadata that warrants showing additional info/icons.
 */
export function hasTodoMeta(todo: Todo, onAddToMyDay?: (id: string) => void): boolean {
  return (
    Boolean(todo.due_date) ||
    Boolean(todo.note) ||
    Boolean(todo.my_day_date) ||
    Boolean(onAddToMyDay) ||
    Boolean(todo.recurrence_rule)
  );
}
